import React, { useState, useEffect } from 'react';
import SearchBar from '../../SeachBar';
import BookingConfirmationEditor from './BookingConfirmationEditor'

const PoolUnit = () => {
    const [isCreatingBC, setIsCreatingBC] = useState(false); // State to toggle CreateCastingView

    const handleBCClick = () => {
        setIsCreatingBC(!isCreatingBC); // Set the selected pool
    };

    return (
        <div className="pool-list">
            <h1 className="title">Booking Confirmations</h1>
            {isCreatingBC ? (
                <BookingConfirmationEditor />
            ) : (
                <>
                    <div style={{ textAlign: 'left' }}>
                        <SearchBar optionalInfos={
                            [<span key={"total"}>Total: 10</span>]} />
                        <button className="button" onClick={() => handleBCClick()}>
                            New Template
                        </button>
                    </div>
                    <div className="table">
                        <div className="table-header">
                            <span className="header-cell">BC Name</span>
                            <span className="header-cell">Description</span>
                        </div>
                        <div
                            className="table-row"
                            onClick={() => handleBCClick()}
                            style={{ cursor: 'pointer' }}
                        >
                            <span className="table-cell">Zalando</span>
                            <span className="table-cell">Summer Collection BCT</span>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default PoolUnit;
